import React, {useState, useEffect} from "react";
import { Link } from "gatsby"

import ContentModule from "../../../modules/content_module";
import {PopularSearch} from "../../../common/queries/common_use_query"

const PopularSearchComponent = (props) => {

    const[list, setList] = useState(0);
    const[showList, setShowList] = useState(false);
    
    const{loading, error, data} = props.popular_search?.length > 0 ? "" : PopularSearch(props.menu_slug);

    const handleShow = event => {
        event.currentTarget.classList.toggle('active-menu');
        setShowList(!showList)
    };

    useEffect(() => {
        data?.menus?.length > 0 && setList(data?.menus[0])
    }, [data])

    var get_popular_search = props.popular_search?.length > 0 ? props.popular_search : list?.popular_search;
    
    //console.log("get_popular_search ==>", get_popular_search)

    return (
        <>
        {get_popular_search?.length > 0 && 
            <div className="menu-list popular">
                <div className="heading-wrap">
                    <h5>Popular Searches</h5>

                    <button onClick={handleShow} >
                        <i className="icon-plus"></i>
                        <i className="icon-minus"></i>
                    </button>
                </div>
                
                <div className={`top-menu ${showList ? "" : "d-none"}`}>
                    {get_popular_search?.map((item, index) => {
                        return(
                            <ContentModule Content={item.popular_search.content} />
                        )
                        })
                    }
                </div>
            </div>
        }
        </>
    )
}
export default PopularSearchComponent;